var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.832 1V2H5.83203V1C5.83203 0.45 5.38203 0 4.83203 0C4.28203 0 3.83203 0.45 3.83203 1V2H2.83203C1.72203 2 0.842031 2.9 0.842031 4L0.832031 18C0.832031 19.1 1.72203 20 2.83203 20H16.832C17.932 20 18.832 19.1 18.832 18V4C18.832 2.9 17.932 2 16.832 2H15.832V1C15.832 0.45 15.382 0 14.832 0C14.282 0 13.832 0.45 13.832 1ZM13.8319 11H10.8319C10.2819 11 9.83193 11.45 9.83193 12V15C9.83193 15.55 10.2819 16 10.8319 16H13.8319C14.3819 16 14.8319 15.55 14.8319 15V12C14.8319 11.45 14.3819 11 13.8319 11ZM3.8321 18H15.8321C16.3821 18 16.8321 17.55 16.8321 17V7H2.8321V17C2.8321 17.55 3.2821 18 3.8321 18Z",
    fill: "#949494"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/Calendar.be576e2c.svg";
export { ForwardRef as ReactComponent };